<template>
  <div class="space-y-10 pb-12 pt-4">
    <div class="flex items-start justify-between">
      <div class="type-label placeholder-text w-20" />
      <div class="placeholder aspect-[4/3] w-24 rounded-lg md:w-32 lg:hidden" />
    </div>
    <div class="flex items-start space-x-20">
      <div class="max-w-4xl flex-grow space-y-5 md:space-y-8 xl:space-y-7">
        <div class="type-heading-3 space-y-[0.3em]">
          <div class="placeholder-text" />
          <div class="placeholder-text" />
          <div class="placeholder-text w-1/4" />
        </div>
        <div class="placeholder h-12 w-44 rounded-full" />
      </div>
      <div class="placeholder hidden aspect-[4/3] w-32 rounded-lg lg:block" />
    </div>
  </div>
</template>
